import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';
import { useFindOneSoftwareQuery } from '../../api/api-hooks';
import { useAuth } from '../../hooks/useAuth';
import { useQuery } from '../../hooks/useQuery';
import { Role } from '../auth/role.enum';
import { getIconForSoftwareType } from '../dashboard/dashboardUtils';
import AdminDocumentationDisplay from './AdminDocumentationDisplay';
import AdminLicenseDownloadDisplay from './AdminLicenseDownloadDisplay';
import AdminVersionDownloadDisplay from './AdminVersionDownloadDisplay';
import DocumentationDisplay from './DocumentationDisplay';
import LicenseDownloadDisplay from './LicenseDownloadDisplay';
import VersionDownloadDisplay from './VersionDownloadDisplay';

const SoftwareDisplay = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const history = useHistory();
  const query = useQuery();
  // Extract software type ID from URL
  const softwareTypeId = pathname.slice(pathname.lastIndexOf('/') + 1);
  const { data: softwareType } = useFindOneSoftwareQuery({
    id: Number(softwareTypeId),
  });
  // Extract company ID from query parameters
  const companyId = query.get('company');

  if (softwareType === undefined) return <CircularProgress></CircularProgress>;
  const goBack = (event: any) => {
    event.preventDefault();
    history.goBack();
  };
  return (
    <Grid container direction='column' alignItems='flex-start' spacing={1}>
      <Grid container item spacing={2} alignItems='center'>
        <Grid item>
          <img
            src={`${process.env.PUBLIC_URL}\\${getIconForSoftwareType(
              softwareType.type
            )}`}
            alt={`Logo for ${softwareType.type}`}
            title={softwareType.type}
            height='80px'
          />
        </Grid>
        <Grid item>
          <Typography variant='h2'>{softwareType.type}</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container alignItems='center'>
          <Button color='primary' onClick={goBack}>
            <ArrowBack style={{ marginRight: '.3rem' }} />
            Go Back
          </Button>
        </Grid>
      </Grid>
      <Grid item container wrap='wrap' spacing={2}>
        {user && user.role === Role.Admin && companyId ? (
          <>
            <AdminVersionDownloadDisplay softwareType={softwareType} />
            <AdminLicenseDownloadDisplay
              softwareType={softwareType}
              companyId={Number(companyId)}
            />
            <AdminDocumentationDisplay
              softwareType={softwareType}
              companyId={Number(companyId)}
            />
          </>
        ) : (
          <>
            <VersionDownloadDisplay softwareType={softwareType} />
            <LicenseDownloadDisplay softwareType={softwareType} />
            <DocumentationDisplay softwareType={softwareType} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default SoftwareDisplay;
